export const FR = 'fr'
export const EN = 'en'
export const SYSTEM = 'system'
export type Localized = (key: string | TemplateStringsArray, config?: {}) => string
export type LangOptions = typeof EN | typeof FR | typeof SYSTEM
